<script>
  export let name
  import { channels, events } from "../stores.js"
  import { navigate } from "svelte-routing"

  import Header from "../components/Header.svelte"
  import EventCreateProcess from "../components/EventCreateProcess.svelte"

  const eventChannels = $events.map((e) => e.channelName)
  const list = $channels
    .map((ch) => ({ name: ch.name }))
    .filter((ch) => !eventChannels.includes(ch.name))
</script>

<Header text="create event" />

<EventCreateProcess {name} />

<div class="container channels">
  <div>Select channel:</div>
  {#each list as { name: channel }}
    <button
      class="button is-fullwidth is-primary"
      on:click={() => navigate(`/events/${name}/channels/${channel}`)}
    >
      {channel}
    </button>
  {/each}
</div>

<style>
  .channels {
    margin: 4px;
  }
  .channels button {
    margin-bottom: 5px;
  }
</style>
